export default {
  path: 'prp',
  name: 'PRP',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/PrpIndex.vue')
}
